// extracted by mini-css-extract-plugin
export default {"card":"Card_card__9bdR+","name":"Card_name__kIM2y","card__img":"Card_card__img__pD2Mb"};